import experimentClient from '@airasia-hotels/core/experiments';

const HOTELS_SHOW_PROMO_BOX = 'promotion_box_feature_flag';
const HOTEL_MANDATORY_LOGIN = 'hotel_mandatory_login';
const HOTEL_SHOW_PRICE_FILTER = 'hotel_price_filter';

const getExpEnvironment = () => {
  return process.env.REACT_APP_ENVIRONMENT === 'PRODUCTION'
    ? 'PRODUCTION'
    : 'DEV';
};

const booleanExperiment = (variable, input, callback) => {
  experimentClient(variable, input, getExpEnvironment(), res =>
    callback(Boolean(res !== null && res))
  );
};

const hotel_promotion_box = (input, callback) => {
  booleanExperiment(HOTELS_SHOW_PROMO_BOX, input, callback);
};

const hotel_mandatory_login = (input, callback) => {
  booleanExperiment(HOTEL_MANDATORY_LOGIN, input, callback);
};
const show_hotel_price_filter = (input, callback) => {
  booleanExperiment(HOTEL_SHOW_PRICE_FILTER, input, callback);
};

export { hotel_promotion_box, hotel_mandatory_login, show_hotel_price_filter };
